import { getApps, initializeApp } from 'firebase/app';

const configs = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

console.log('[fb]', configs);

async function setupFirestoreEmulator() {
  const { connectFirestoreEmulator, getFirestore } = await import('firebase/firestore');
  const firestore = getFirestore();
  connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
}

function initialize() {
  if (getApps().length === 0) {
    try {
      const app = initializeApp(configs);

      if (import.meta.env.VITE_FIRESTORE_EMULATE === 'yes') {
        console.log('using firestore emulator');
        void setupFirestoreEmulator();
      }

      if (import.meta.env.VITE_FUNCTIONS_EMULATE === 'yes') {
        console.log('using functions emulator');
        import('firebase/functions').then(({ getFunctions, connectFunctionsEmulator }) => {
          const functions = getFunctions(app);
          connectFunctionsEmulator(functions, '127.0.0.1', 5001);
        });
      }

      return app;
    } catch (e) {
      console.warn(e);
    }
  }

  return getApps()[0];
}

export const app = initialize();
